import Button from "@material-ui/core/Button";
import Collapse from "@material-ui/core/Collapse";
import Divider from "@material-ui/core/Divider";
import Grid from "@material-ui/core/Grid";
import withStyles from "@material-ui/core/styles/withStyles";
import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";
import Tooltip from "@material-ui/core/Tooltip";
import get from "lodash/get";
import Moment from "moment";
import PermissionDeniedComp from "Component/PermissionDeniedComp/PermissionDeniedComp";

import { withSnackbar } from "notistack";
import PropTypes from "prop-types";
import React from "react";
import { FormattedMessage, IntlProvider } from "react-intl";
import ReactQuill from "react-quill";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { instance } from "../../../Actions/AxiosInstance";
import {
  CheckActionPermission,
  CheckEditPermission,
} from "../../../Actions/commonAction";
import { ChangeLanguage } from "../../../Actions/LanguageAction";
import broadcast from "../../../Assets/Icons/Broadcast/broadcast-16px.svg";
import DownloadIcon from "../../../Assets/Icons/Download/download-16px.svg";
import selectAll from "../../../Assets/Svg/select-all.svg";
import TabContainer from "../../../Component/Common/TabContainer";
import { FEATUREKEYS } from "../../../Constants/Featurekeys";
import createstore from "../../../store";
import EmpDirectoryDetails from "./EmpDirectoryDetails";
import FilterComponent from "./filter";

let shouldCallAPI = true;

TabContainer.propTypes = {
  children: PropTypes.node.isRequired,
};

const styles = (theme) => ({
  root: {
    flexGrow: 1,
    width: "100%",
    backgroundColor: theme.palette.background.paper,
    marginRight: "10px",
  },

  badge: {
    top: 1,
    right: -15,
    border: `2px solid ${
      theme.palette.type === "light"
        ? theme.palette.grey[200]
        : theme.palette.grey[900]
    }`,
  },
});

const modules = {
  toolbar: [
    [{ header: [1, 2, 3, 4, 5, 6, false] }],
    ["bold", "italic", "underline", "strike", "blockquote"],
    [
      { list: "ordered" },
      { list: "bullet" },
      { indent: "-1" },
      { indent: "+1" },
    ],
    ["link"], // image
    ["clean"],
  ],
};

const formats = [
  "header",
  "bold",
  "italic",
  "underline",
  "strike",
  "blockquote",
  "list",
  "bullet",
  "indent",
  "link",
]; // 'image'
class Directory extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      value: 3,
      anchorEl: null,
      expanded: false,
      isSelected: false,
      SelectAllFlag: null,
      filterEL: null,
      open: false,
      maritalStatusList: [],
      genderList: [],
      bloodGroupList: [],
      businessUnits: [],
      team: [],
      fields: {
        mailbody: null,
      },
      department: [],
      ChallengeList: [],
      EmploymentTypeList: [],
      OfficeLocationList: [],
      EmployeesDepartmentList: [],
      ManagersList: { fullname: "Select Manager", employeeid: "" },
      TeamList: [],
      filterOptions: [],
      employeeeStatusList: [],
      filterSearch: [],
      selectedFilter: [],
      getEmpList: false,
      rowsPerPage: 500,
      page: 0,
      rowsPerPageOptions: [],
      TotalRecordCount: 0,
      displayRecordCount: 0,
      offset: 0,
      isteammember: false,
      isExport: false,
      isSendMail: false,
      expandClose: false,
      actionidList: "",
      startDate: new Date(),
      endDate: new Date(),
      drawerOpen: false,
      message: "",
      permissions: { readOnly: false, editable: false },
    };

    this.handleScroll = this.handleScroll.bind(this);
    this.handleAddFilterClick = this.handleAddFilterClick.bind(this);
    this.handleClickAway = this.handleClickAway.bind(this);
    this.onFilterSave = this.onFilterSave.bind(this);
    this.onFilterValueChange = this.onFilterValueChange.bind(this);
    this.resetFilters = this.resetFilters.bind(this);
    this.getList = this.getList.bind(this);
  }

  componentWillMount() {
    this.props.ChangeLanguage("directory,navigation");
    const { SubscriptionInfo } = createstore.getState();
    const { subscriptionid } = SubscriptionInfo.SubscriptionData;
    const { AuthenticationAction } = createstore.getState();
    // let accountid = SubscriptionInfo.SubscriptionData.accountid;
    // let countrytimezoneid = SubscriptionInfo.SubscriptionData.countrytimezoneid;
    // let employeeid = SubscriptionInfo.SubscriptionData.employeeid;
    if (AuthenticationAction.login.employeeid != "0") {
      this.setState({ value: 3, isteammember: true });
    }
    this.setState({ subscriptionid });
  }

  componentDidMount() {
    // window.addEventListener("scroll", this.handleScroll1);
    const { AuthenticationAction } = createstore.getState();
    const empattr = AuthenticationAction.login.features.find(
      (feature) => feature.featureid == FEATUREKEYS.employeeAttributes,
    );

    const compattr = AuthenticationAction.login.features.find(
      (feature) => feature.featureid == FEATUREKEYS.companyAttributes,
    );

    const [isTrue, permissions] = CheckActionPermission("directory");
    if (isTrue) {
      this.GetMaritalStatus();
      this.GetGender();
      this.GetBloodGroup();
      this.GetBusinessUnits();
      this.GetTeam();
      this.GetChallenge();
      this.GetEmployeTypeList();
      this.GetOfficeLocationList();
      this.GetEmployeesDepartmentList();
      this.GetManagersList();
      this.GetEmpStatusList();
      this.GetBankList();
      this.GetEmployeStageList();

      const a = [];
      let i = "A".charCodeAt(0);
      const j = "Z".charCodeAt(0);
      for (; i <= j; ++i) {
        a.push(String.fromCharCode(i));
      }
      let filterOptions = [];
      if (empattr) {
        filterOptions = [
          ...filterOptions,
          {
            displayvalue: 0,
            displayname: "First Name",
            key: "LbFirstName",
            value: "",
            open: false,
            type: "input",
            radio: false,
            startDate: null,
            endDate: null,
            value1: null,
            value2: null,
          },
          {
            displayvalue: 1,
            displayname: "Last Name",
            key: "LbLastName",
            value: "",
            open: false,
            type: "input",
            radio: false,
            startDate: null,
            endDate: null,
            value1: null,
            value2: null,
          },
          {
            displayvalue: 2,
            displayname: "Blood Group",
            key: "LbBloodGroup",
            value: "",
            open: false,
            type: "select",
            radio: false,
            startDate: null,
            endDate: null,
            value1: null,
            value2: null,
          },
          {
            displayvalue: 3,
            displayname: "Gender",
            key: "LbGender",
            value: "",
            open: false,
            type: "select",
            radio: false,
            startDate: null,
            endDate: null,
            value1: null,
            value2: null,
          },
          {
            displayvalue: 4,
            displayname: "Marital Status",
            key: "LbMaritalStatus",
            value: "",
            open: false,
            type: "select",
            startDate: null,
            radio: false,
            endDate: null,
            value1: null,
            value2: null,
          },
          {
            displayvalue: 5,
            displayname: "Birthdays",
            key: "LbBob",
            value: "",
            open: false,
            type: "bdate",
            radio: true,
            toggle: false,
            startDate: null,
            endDate: null,
            value1: null,
            value2: null,
          },
          {
            displayvalue: 6,
            displayname: "Marriage Anniversary",
            key: "LbMarriageAnni",
            value: "",
            open: false,
            radio: true,
            toggle: false,
            type: "madate",
            startDate: null,
            endDate: null,
            value1: null,
            value2: null,
          },
          {
            displayvalue: 7,
            displayname: "Mobile Number",
            key: "LbMobileNumber",
            value: "",
            open: false,
            radio: false,
            type: "phone",
            startDate: null,
            endDate: null,
            value1: null,
            value2: null,
          },
          {
            displayvalue: 8,
            displayname: "Bank Name",
            key: "LbBankname",
            value: "",
            open: false,
            type: "select",
            startDate: null,
            radio: false,
            endDate: null,
            value1: null,
            value2: null,
          },
        ];
      }
      if (compattr) {
        filterOptions = [
          ...filterOptions,
          {
            displayvalue: 9,
            displayname: "Date of Joining",
            key: "LbDoJ",
            value: "",
            radio: true,
            toggle: false,
            open: false,
            type: "jdate",
            startDate: null,
            endDate: null,
            value1: null,
            value2: null,
          },
          {
            displayvalue: 10,
            displayname: "Notice Date",
            key: "LbNd",
            value: "",
            radio: true,
            toggle: false,
            open: false,
            type: "ndate",
            startDate: null,
            endDate: null,
            value1: null,
            value2: null,
          },
          {
            displayvalue: 11,
            displayname: "Exit Date",
            key: "LbEd",
            value: "",
            radio: true,
            toggle: false,
            open: false,
            type: "edate",
            startDate: null,
            endDate: null,
            value1: null,
            value2: null,
          },
          {
            displayvalue: 12,
            displayname: "Employment Stage",
            key: "LbEmpstage",
            value: "",
            open: false,
            type: "select",
            radio: false,
            startDate: null,
            endDate: null,
            value1: null,
            value2: null,
          },
          {
            displayvalue: 13,
            displayname: "Employment Type",
            key: "LbEmptype",
            value: "",
            open: false,
            radio: false,
            type: "select",
            startDate: null,
            endDate: null,
            value1: null,
            value2: null,
          },
          {
            displayvalue: 14,
            displayname: "Employee’s Status",
            key: "LbEmpstatus",
            value: "",
            open: false,
            radio: false,
            type: "select",
            startDate: null,
            endDate: null,
            value1: null,
            value2: null,
          },
          {
            displayvalue: 15,
            displayname: "Self Service",
            key: "LbSelfService",
            value: "",
            options: [
              { displayname: "None", displayvalue: null },
              { displayname: "Yes", displayvalue: true },
              { displayname: "No", displayvalue: false },
            ],
            open: false,
            radio: false,
            type: "select",
            startDate: null,
            endDate: null,
            value1: null,
            value2: null,
          },
          {
            displayvalue: 16,
            displayname: "Office Location",
            key: "LbOfficeLocation",
            value: "",
            open: false,
            radio: false,
            type: "select",
            startDate: null,
            endDate: null,
            value1: null,
            value2: null,
          },
          {
            displayvalue: 17,
            displayname: "Business Unit",
            key: "LbBU",
            value: "",
            open: false,
            radio: false,
            type: "select",
            startDate: null,
            endDate: null,
            value1: null,
            value2: null,
          },
          {
            displayvalue: 18,
            displayname: "Department",
            key: "LbEmpDepartment",
            value: "",
            open: false,
            radio: false,
            type: "select",
            startDate: null,
            endDate: null,
            value1: null,
            value2: null,
          },
          {
            displayvalue: 19,
            displayname: "Team",
            key: "LbTeam",
            value: "",
            open: false,
            radio: false,
            type: "select",
            startDate: null,
            endDate: null,
            value1: null,
            value2: null,
          },
          {
            displayvalue: 20,
            displayname: "Manager’s Team Members",
            key: "LbManagerTeam",
            value: "",
            fullname: "",
            open: false,
            radio: false,
            type: "select",
            startDate: null,
            endDate: null,
            value1: null,
            value2: null,
          },
        ];
      }
      this.setState({
        filterSearch: a,
        filterOptions,
        permissions,
        empattr,
        compattr,
      });
    } else {
      this.setState({ permissiondenied: true });
    }
  }

  componentWillUnmount() {
    // window.removeEventListener("scroll", this.handleScroll1);
  }

  handleScroll1 = () => {
    const windowBottom =
      Math.floor(window.innerHeight * 0.65) + window.pageYOffset;
    // if (windowBottom + 20 >= Math.floor(window.innerHeight * 0.65)) {
    // if (shouldCallAPI) {
    const newoffset = this.state.offset + this.state.rowsPerPage;
    if (this.state.TotalRecordCount > newoffset) {
      shouldCallAPI = false;
      this.setState({
        offset: newoffset,
        getEmpList: true,
      });
      setTimeout(() => {
        shouldCallAPI = true;
      }, 5000);
    }
    // this.props.GetEmployeeRequestList(true);
    // }
    // }
  };

  handleScroll() {
    // const windowHeight = "innerHeight" in window ? window.innerHeight : document.documentElement.offsetHeight;
    // const { body } = document;
    // const html = document.documentElement;
    // const docHeight = Math.max(
    //   body.scrollHeight,
    //   body.offsetHeight,
    //   html.clientHeight,
    //   html.scrollHeight,
    //   html.offsetHeight,
    // );
    // const windowBottom = windowHeight + window.pageYOffset;
    // if (windowBottom >= docHeight) {
    //   const newoffset = this.state.offset + this.state.rowsPerPage;
    //   if (this.state.TotalRecordCount > newoffset) {
    //     this.setState({
    //       offset: newoffset,
    //       getEmpList: true,
    //     });
    //   }
    // } else {
    //   this.setState({
    //     message: "no data",
    //   });
    // }
  }

  addFilter = (option) => {
    const { selectedFilter } = this.state;
    const index = selectedFilter.findIndex(
      (x) => x.displayvalue == option.displayvalue,
    );
    selectedFilter[index].open = !option.open;
    selectedFilter[index].startDate = option.value1;
    selectedFilter[index].endDate = option.value2;
    selectedFilter[index].value1 = Moment(this.state.startDate).format(
      "YYYY-DD-MM",
    );
    selectedFilter[index].value2 = Moment(this.state.endDate).format(
      "YYYY-DD-MM",
    );
    const { rangeDate } = this.state;
    const { startDate } = this.state;
    const { endDate } = this.state;
    // let startDate = new Date()
    // let endDate =  new Date()

    this.setState({
      selectedFilter,
      rangeDate,
      endDate,
      startDate,
    });
  };

  handleClick = (event) => {
    const { selectedFilter } = this.state;
    for (const option of selectedFilter) {
      option.open = false;
    }
    this.setState({ anchorEl: event.currentTarget, selectedFilter });
  };

  closePreviousFilter = (option) => {
    const { selectedFilter } = this.state;
    let index = selectedFilter.findIndex(
      (x) => x.displayvalue == option.displayvalue,
    );
    index -= 1;
    selectedFilter[index].open = false;
    this.setState({ selectedFilter });
  };
  // closeFilter(option) {
  //     this.setState({ anchorEl: event.currentTarget });
  // }

  onSave(option) {
    const { selectedFilter } = this.state;
    const index = selectedFilter.findIndex(
      (x) => x.displayvalue == option.displayvalue,
    );
    selectedFilter[index].open = false;
    this.setState({ selectedFilter, getEmpList: true });
  }

  getList(displayRecordCount, TotalRecordCount) {
    const rowsPerPageOptions = [10];
    const count = Math.floor(TotalRecordCount / 500);
    for (let i = 1; i <= Number(count); i++) {
      rowsPerPageOptions.push(Number(500 * i));
    }
    rowsPerPageOptions.push(Number(TotalRecordCount));
    this.setState(
      {
        getEmpList: false,
        rowsPerPageOptions,
        TotalRecordCount,
        displayRecordCount,
        isExport: false,
      },
      () => {},
    );
  }

  GetBankList() {
    const data1 = {
      countryid: null,
      subscriptionid: this.state.subscriptionid,
    };
    instance
      .post(`superuser/allbankmaster`, data1)
      .then((result) => {
        const BankList = [];
        BankList.push(
          { displayname: "None", displayvalue: "" },
          ...result.data.result,
        );
        this.setState({ BankList });
        const bankindex = this.state.filterOptions.findIndex(
          (option) => option.displayname === "Bank Name",
        );
        const filteroptions = this.state.filterOptions;
        if (filteroptions[bankindex]) {
          filteroptions[bankindex].options = BankList;
        }
        this.setState({
          filterOptions: filteroptions,
        });
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
  }

  setValue(option, event) {
    const { selectedFilter } = this.state;
    const index = selectedFilter.findIndex(
      (x) => x.displayvalue == option.displayvalue,
    );
    option.value = event.target.value || "";
    selectedFilter[index] = option;
    // console.log('selectedfilter', selectedFilter, 'option', option, 'event', event);
    this.setState({ selectedFilter });
  }

  // setMobile(option, value) {
  //
  //     let selectedFilter = this.state.selectedFilter
  //     let index = selectedFilter.findIndex(x => x.displayvalue == option.displayvalue)
  //     option.value = value || "";
  //     selectedFilter[index] = option;
  //     this.setState({ selectedFilter })
  // }

  OnPhoneChange(option, field, value) {
    // console.log('safsfZSF',option,field,value);
    const { selectedFilter } = this.state;
    const index = selectedFilter.findIndex(
      (x) => x.displayvalue == option.displayvalue,
    );
    // field = field.replace(/[ !@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/g, '');
    const mobile = JSON.parse(JSON.stringify(field));
    let no = field.replace(/[ !@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/g, "");
    no = no.replace(value.dialCode, "");
    no = no.trim();
    option.value = no || "";
    option.mobile = mobile || "";
    selectedFilter[index] = option;
    // console.log('selectedfilter', selectedFilter, 'option', option, 'filed', field, 'value', value);
    this.setState({ selectedFilter });
  }

  UpdateSelectedDropdownItem(option, selectedName, selectedItem) {
    // this.setState({ [name]: selectedItem });
    const { selectedFilter } = this.state;
    const index = selectedFilter.findIndex(
      (x) => x.displayvalue == option.displayvalue,
    );
    option.value = selectedItem.displayvalue || "";
    option.selectedname = selectedItem.displayname || "";
    selectedFilter[index] = option;
    // console.log('selectedfilter', selectedFilter, 'name', selectedName, 'option', option);
    this.setState({ selectedFilter, [selectedName]: selectedItem });
  }

  UpdateManagerId(option, selectedName, selectedItem) {
    const { selectedFilter } = this.state;
    const index = selectedFilter.findIndex(
      (x) => x.displayvalue == option.displayvalue,
    );
    // option.value = selectedItem.displayvalue || "";
    option.value = selectedItem.employeeid;
    option.fullname = selectedItem.fullname || "";
    selectedFilter[index] = option;
    this.setState({ selectedFilter, [selectedName]: selectedItem });
  }

  handleChangePage(event, page) {
    // let offset = (this.state.rowsPerPage * page) + 1;
    const offset = this.state.rowsPerPage * page;
    this.setState({ page, offset, getEmpList: true }, () => {});
  }

  handleChangeRowsPerPage(event, page) {
    const rowsPerPage = event.target.value;
    // let offset = (rowsPerPage * this.state.page) + 1;
    const offset = rowsPerPage * this.state.page;
    this.setState({ rowsPerPage, getEmpList: true }, () => {});
  }

  selectDate(option, args) {
    if (!args.date) {
      return;
    }
    // let rangeDate = args.date
    const date = args.date.split(" - ");
    const rangeDate = args.date;
    const startDate = date[0].trim();
    const endDate = date[1].trim();

    const { selectedFilter } = this.state;
    const index = selectedFilter.findIndex(
      (x) => x.displayvalue == option.displayvalue,
    );
    // option.value1 = rangeDate;
    option.value1 = startDate || "";
    option.value2 = endDate || "";
    // option.rangeDate = rangeDate
    selectedFilter[index] = option;
    this.setState({
      selectedFilter,
      rangeDate,
      startDate,
      endDate,
    });
  }

  // handleToggle = (option) => {
  //     let selectedFilter = this.state.selectedFilter
  //     let index = selectedFilter.findIndex(x => x.displayvalue == option.displayvalue)
  //     selectedFilter[index].open = !option.open;
  //     this.setState({ selectedFilter });
  // };

  handleExpandClick = () => {
    this.setState((state) => ({
      expanded: !state.expanded,
      expandClose: !state.expandClose,
      SelectAllFlag: null,
    }));
  };

  ChangeofMembers = (event, value) => {
    let isteammember;
    value == 0 ? (isteammember = true) : (isteammember = false);
    this.setState({
      value,
      getEmpList: true,
      isteammember,
      offset: 0,
    });
  };

  handleSelfServiceChange(option, event) {
    const { selectedFilter } = this.state;
    const index = selectedFilter.findIndex(
      (x) => x.displayvalue == option.displayvalue,
    );
    option.value = event.target.value || "";
    selectedFilter[index] = option;
    this.setState({ selectedFilter });
  }

  handleClose = (option) => {
    const { selectedFilter } = this.state;

    const index = selectedFilter.findIndex(
      (x) => x.displayvalue == option.displayvalue,
    );
    if (index != -1) {
      this.setState({ anchorEl: null });
      return false;
    }
    if (option.value) {
      option.value = "";
    }
    if (option.value1) {
      option.value1 = "";
    }
    if (option.value2) {
      option.value2 = "";
    }
    if (option.mobile) {
      option.mobile = "";
    }
    if (option.fullname) {
      option.fullname = "";
    }

    if (option.selectedname) {
      option.selectedname = "";
    }
    if (option.startDate) {
      option.startDate = "";
    }
    if (option.endDate) {
      option.endDate = "";
    }
    const startDate = new Date();
    const endDate = new Date();
    if (option.displayvalue == 3) this.setState({ selectedMaritalStatus: {} });
    if (option.displayvalue == 4) this.setState({ selectedGender: {} });
    if (option.displayvalue == 5) this.setState({ selectedBloodGroup: {} });
    if (option.displayvalue == 7) this.setState({ selectedBusinessUnit: {} });
    if (option.displayvalue == 9) this.setState({ selectedTeam: {} });
    if (option.displayvalue == 18) {
      this.setState({ selectedEmployeeeStatus: {} });
    }
    if (option.displayvalue == 19) {
      this.setState({ selectedEmploymentType: {} });
    }
    if (option.displayvalue == 20) {
      this.setState({ selectedOfficeLocation: {} });
    }
    if (option.displayvalue == 21) {
      this.setState({ selectedEmployeesDepartment: {} });
    }
    if (option.displayvalue == 23) this.setState({ selectedManager: {} });
    selectedFilter.push(option);
    this.setState(
      (state) => ({
        anchorEl: null,
        selectedFilter,
        startDate,
        endDate,
      }),
      () => {
        this.addFilter(option);
      },
    );
  };

  removeFilter = (option) => {
    const { selectedFilter } = this.state;
    const index = selectedFilter.findIndex(
      (x) => x.displayvalue == option.displayvalue,
    );
    selectedFilter.splice(index, 1);
    // this.setState(state => ({ selectedFilter }))
    this.setState({ selectedFilter, getEmpList: true });
  };

  handleFilterClick = (event) => {
    this.setState({ filterEL: event.currentTarget });
  };

  handleFilterClose = () => {
    this.setState({ filterEL: null });
  };

  SelectAllFlag() {
    // this.setState({ SelectAllFlag: this.state.SelectAllFlag ? null : true, isExport: !this.state.SelectAllFlag ? false : null })
    this.setState({
      SelectAllFlag: !this.state.SelectAllFlag,
      isExport: !this.state.SelectAllFlag ? false : null,
    });
  }

  ExportData(flag) {
    this.setState({ isExport: flag, SelectAllFlag: null });
  }

  sendMail(flag, expandClose) {
    let expanded;
    if (expandClose == true) {
      expanded = false;
      this.setState({ fields: { mailbody: null }, expandClose: false });
    } else {
      expanded = true;
      this.setState({ fields: { ...this.state.fields } });
    }
    // flag ? this.state.expanded = false :  this.state.expanded = true, this.setState({ fields: { ...this.state.fields } })
    this.setState({ isSendMail: flag, expanded });
  }

  GetSpecificCharacter(option, event) {
    const char = option;
    this.setState({ char });
  }

  checkAnchor() {
    if (this.state.anchorEl) {
      this.setState({ anchorEl: null });
    }
    // selectedFilter[index].open = false;
  }

  OnFieldChange(field, type, e) {
    const { fields } = this.state;
    // field == "mailbody" ? fields[field] = e : fields[field] = e.target.value;
    fields.mailbody = e;
    this.setState({ fields });
  }

  GetEmployeesDepartmentList() {
    const data = {
      featurekey: "directory",
    };
    // instance.get(`subscription/employeeswithdepartment/${this.state.subscriptionid}`).then(result => {
    instance
      .post(`subscription/alldepartment`, data)
      .then((result) => {
        const EmployeesDepartmentList = [];
        EmployeesDepartmentList.push(
          // { "displayname": "Select Department", "displayvalue": '' },
          { displayname: "None", displayvalue: "" },
          ...result.data.result,
        );
        this.setState({ EmployeesDepartmentList });
        const empdepartmentindex = this.state.filterOptions.findIndex(
          (option) => option.displayname === "Department",
        );
        const filteroptions = this.state.filterOptions;
        if (filteroptions[empdepartmentindex]) {
          filteroptions[empdepartmentindex].options = EmployeesDepartmentList;
        }
        this.setState({
          filterOptions: filteroptions,
        });
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
  }

  GetManagersList() {
    instance
      .get(`subscription/allprimarymanagerlist`)
      .then((result) => {
        const ManagersList = [];
        ManagersList.push(
          {
            fullname: "No Manager",
            employeeid: 0,
          },
          ...result.data.result,
        );
        this.setState({ ManagersList });
        const managerindex = this.state.filterOptions.findIndex(
          (option) => option.displayname === "Manager’s Team Members",
        );
        const filteroptions = this.state.filterOptions;
        if (filteroptions[managerindex]) {
          filteroptions[managerindex].options = ManagersList;
        }
        this.setState({
          filterOptions: filteroptions,
        });
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
  }

  GetMaritalStatus() {
    instance
      .get("superuser/getmastercode/MaritalStatus")
      .then((result) => {
        const maritalStatusList = [];
        maritalStatusList.push(
          { displayname: "None", displayvalue: "" },
          ...result.data.result,
        );
        this.setState({ maritalStatusList });
        const marstatusindex = this.state.filterOptions.findIndex(
          (option) => option.displayname === "Marital Status",
        );
        const filteroptions = this.state.filterOptions;
        if (filteroptions[marstatusindex]) {
          filteroptions[marstatusindex].options = maritalStatusList;
        }
        this.setState({
          filterOptions: filteroptions,
        });
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
  }

  GetGender() {
    instance
      .get("superuser/getgender")
      .then((result) => {
        const genderList = [];
        genderList.push(
          { displayname: "None", displayvalue: "" },
          ...result.data.result,
        );
        this.setState({ genderList });
        const genderindex = this.state.filterOptions.findIndex(
          (option) => option.displayname === "Gender",
        );
        const filteroptions = this.state.filterOptions;

        if (filteroptions[genderindex]) {
          filteroptions[genderindex].options = genderList;
        }
        this.setState({
          filterOptions: filteroptions,
        });
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
  }

  GetBusinessUnits() {
    const data = {
      featurekey: "directory",
    };
    instance
      .post("subscription/allbusinessunit", data)
      .then((result) => {
        const businessUnits = [];
        businessUnits.push(
          { displayname: "None", displayvalue: "" },
          ...result.data.result,
        );
        this.setState({ businessUnits });
        const businesunitindex = this.state.filterOptions.findIndex(
          (option) => option.displayname === "Business Unit",
        );
        const filteroptions = this.state.filterOptions;
        if (filteroptions[businesunitindex]) {
          filteroptions[businesunitindex].options = businessUnits;
        }
        this.setState({
          filterOptions: filteroptions,
        });
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
  }

  GetChallenge() {
    instance
      .get("superuser/getmastercode/ChallengedType")
      .then((result) => {
        const ChallengeList = [];
        ChallengeList.push(
          { displayname: "None", displayvalue: "" },
          ...result.data.result,
        );
        this.setState({ ChallengeList });
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
  }

  GetTeam() {
    instance
      .get("subscription/allteam")
      .then((result) => {
        const team = [];
        team.push(
          { displayname: "All Team", displayvalue: "" },
          ...result.data.result,
        );
        this.setState({ team });
        const teamindex = this.state.filterOptions.findIndex(
          (option) => option.displayname === "Team",
        );
        const filteroptions = this.state.filterOptions;
        if (filteroptions[teamindex]) {
          filteroptions[teamindex].options = team;
        }
        this.setState({
          filterOptions: filteroptions,
        });
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
  }

  GetBloodGroup() {
    instance
      .get("superuser/getmastercode/BloodGroupType")
      .then((result) => {
        const bloodGroupList = [];
        bloodGroupList.push(
          { displayname: "None", displayvalue: "" },
          ...result.data.result,
        );
        this.setState({ bloodGroupList });
        const bgindex = this.state.filterOptions.findIndex(
          (option) => option.displayname === "Blood Group",
        );
        const filteroptions = this.state.filterOptions;
        if (filteroptions[bgindex]) {
          filteroptions[bgindex].options = bloodGroupList;
        }
        this.setState({
          filterOptions: filteroptions,
        });
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
  }

  GetEmployeStageList() {
    instance
      .get("superuser/getmastercode/EmployeeStage")
      .then((result) => {
        const EmploymentTypeList = [];
        EmploymentTypeList.push(
          { displayname: "None", displayvalue: "" },
          ...result.data.result,
        );
        this.setState({ EmploymentTypeList });
        const employeetypeindex = this.state.filterOptions.findIndex(
          (option) => option.displayname === "Employment Stage",
        );
        const filteroptions = this.state.filterOptions;
        if (filteroptions[employeetypeindex]) {
          filteroptions[employeetypeindex].options = EmploymentTypeList;
        }
        this.setState({
          filterOptions: filteroptions,
        });
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
  }

  GetEmployeTypeList() {
    instance
      .get("superuser/getmastercode/EmploymentType")
      .then((result) => {
        const EmploymentTypeList = [];
        EmploymentTypeList.push(
          { displayname: "None", displayvalue: "" },
          ...result.data.result,
        );
        this.setState({ EmploymentTypeList });
        const employeetypeindex = this.state.filterOptions.findIndex(
          (option) => option.displayname === "Employment Type",
        );
        const filteroptions = this.state.filterOptions;
        if (filteroptions[employeetypeindex]) {
          filteroptions[employeetypeindex].options = EmploymentTypeList;
        }
        this.setState({
          filterOptions: filteroptions,
        });
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
  }

  GetOfficeLocationList() {
    const data = {
      featurekey: "directory",
      subscriptionid: this.state.subscriptionid,
    };
    instance
      .post(`subscription/allcompanylocation`, data)
      .then((result) => {
        const OfficeLocationList = [];
        OfficeLocationList.push(
          { displayname: "None", displayvalue: "" },
          ...result.data.result,
        );
        this.setState({ OfficeLocationList });
        const officelocationindex = this.state.filterOptions.findIndex(
          (option) => option.displayname === "Office Location",
        );
        const filteroptions = this.state.filterOptions;
        if (filteroptions[officelocationindex]) {
          filteroptions[officelocationindex].options = OfficeLocationList;
        }
        this.setState({
          filterOptions: filteroptions,
        });
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
  }

  GetEmpStatusList() {
    instance
      .get(`superuser/getmastercode/EmployeeStatus`)
      .then((result) => {
        const employeeeStatusList = [];
        employeeeStatusList.push(
          { displayname: "None", displayvalue: "" },
          ...result.data.result,
        );
        this.setState({ employeeeStatusList });
        const employeestatusindex = this.state.filterOptions.findIndex(
          (option) => option.displayname === "Employee’s Status",
        );
        const filteroptions = this.state.filterOptions;
        if (filteroptions[employeestatusindex]) {
          filteroptions[employeestatusindex].options = employeeeStatusList;
        }
        this.setState({
          filterOptions: filteroptions,
        });
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
  }

  onFilterValueChange(event, selectedFilter) {
    if (selectedFilter.type === "input") {
      const filteroption = this.state.filterOptions;
      const index = filteroption.findIndex(
        (option) => option.displayname === selectedFilter.displayname,
      );
      if (event || event !== "") {
        filteroption[index].value = event;
        this.setState({ filterOptions: filteroption });
      } else {
        filteroption[index].value = "";
        this.setState({ filterOptions: filteroption });
      }
    } else if (selectedFilter.type === "select") {
      const filteroption = this.state.filterOptions;
      const index = filteroption.findIndex(
        (option) => option.displayname === selectedFilter.displayname,
      );
      if (selectedFilter.displayname === "Manager’s Team Members") {
        if (event.fullname !== "No Manager") {
          filteroption[index].value = event;
          this.setState({ filterOptions: filteroption });
        } else {
          filteroption[index].value = "";
          this.setState({ filterOptions: filteroption });
        }
      } else if (selectedFilter.displayname === "Bank Name") {
        if (event) {
          const bank = this.state.filterOptions[index].options.find(
            (option) => option.displayvalue == event,
          );
          filteroption[index].value = bank.displayname;
          this.setState({ filterOptions: filteroption });
        } else {
          this.setState({ filterOptions: filteroption });
        }
      } else if (event != null || event != "") {
        filteroption[index].value = event;
        this.setState({ filterOptions: filteroption });
      } else {
        this.setState({ filterOptions: filteroption });
      }
    } else if (selectedFilter.type === "phone") {
      const filteroption = this.state.filterOptions;
      const index = filteroption.findIndex(
        (option) => option.displayname === selectedFilter.displayname,
      );
      if (event || event !== "") {
        filteroption[index].value = event;
        filteroption[index].mobile = selectedFilter.mobile;
        this.setState({ filterOptions: filteroption });
      } else {
        filteroption[index].value = "";
        filteroption[index].mobile = "";
        this.setState({ filterOptions: filteroption });
      }
    } else if (
      selectedFilter.type === "ndate" ||
      selectedFilter.type === "bdate" ||
      selectedFilter.type === "edate" ||
      selectedFilter.type === "madate" ||
      selectedFilter.type === "jdate"
    ) {
      const filteroption = this.state.filterOptions;
      const index = filteroption.findIndex(
        (option) => option.displayname === selectedFilter.displayname,
      );
      if (selectedFilter.value || selectedFilter.value !== "") {
        filteroption[index].value = selectedFilter.value;
        filteroption[index].value1 = selectedFilter.value1;
        filteroption[index].value2 = selectedFilter.value2;
        this.setState({
          filterOptions: filteroption,
          rangeDate: selectedFilter.value,
          startDate: selectedFilter.value1,
          endDate: selectedFilter.value2,
        });
      } else {
        filteroption[index].value = "";
        filteroption[index].value1 = "";
        filteroption[index].value2 = "";
        this.setState({
          filterOptions: filteroption,
          rangeDate: "",
          startDate: Moment(this.state.startDate).format("YYYY-DD-MM"),
          endDate: Moment(this.state.startDate).format("YYYY-DD-MM"),
        });
      }
    } else if (selectedFilter.type === "radio") {
      const filteroption = this.state.filterOptions;
      const index = filteroption.findIndex(
        (option) => option.displayname === selectedFilter.displayname,
      );

      filteroption[index].value = event;
      this.setState({ filterOptions: filteroption });
    }
  }

  handleAddFilterClick() {
    this.setState((state) => {
      state.drawerOpen = true;
      return state;
    });
  }

  handleClickAway(popupStatus) {
    this.setState({
      drawerOpen: popupStatus,
    });
  }

  onFilterSave(popupStatus, selectedFilters, filterOptions) {
    this.setState({
      selectedFilter: selectedFilters,
      filterOptions,
      getEmpList: true,
      drawerOpen: popupStatus,
      offset: 0,
    });
  }

  resetFilters(open) {
    this.setState({
      filterOptions: get(this.state, "filterOptions", []).map((f) => ({
        ...f,
        value: null,
        value1: null,
        value2: null,
      })),
      selectedFilter: [],
      getEmpList: true,
      drawerOpen: false,
      offset: 0,
    });
  }

  render() {
    const { value } = this.state;
    const language = this.props.Language.directory;
    const migratedirectory =
      this.props.AuthenticationAction.login.migration.find(
        (x) => x.moduletypeid == 6,
      );
    return (
      <IntlProvider locale="en" messages={language}>
        {this.state.permissiondenied ? (
          <div className="position-rel">
            <PermissionDeniedComp />
          </div>
        ) : (
          <main
            className="content-outer-wrapper"
            // onScroll={this.handleScroll1}
            onClick={() => this.checkAnchor()}
          >
            <div>
              <div className="directory-page">
                <Grid container>
                  <Grid item xs={12} md={12} sm={12} className="width100">
                    <div className="position-rel">
                      <div>
                        {CheckEditPermission("exportDirectoryData") && (
                          <div className="inlineClass floatleft margin-right-20">
                            <Tooltip
                              title={
                                <FormattedMessage
                                  id="Lbselectall"
                                  defaultMessage="Select All"
                                />
                              }
                              placement="top"
                            >
                              <div
                                className="inlineClass padding-left-10 cursurpointer"
                                onClick={this.SelectAllFlag.bind(this)}
                              >
                                {/* <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                              >
                                <path d="M0 0h24v24H0z" fill="none" />
                                <path d="M3 5h2V3c-1.1 0-2 .9-2 2zm0 8h2v-2H3v2zm4 8h2v-2H7v2zM3 9h2V7H3v2zm10-6h-2v2h2V3zm6 0v2h2c0-1.1-.9-2-2-2zM5 21v-2H3c0 1.1.9 2 2 2zm-2-4h2v-2H3v2zM9 3H7v2h2V3zm2 18h2v-2h-2v2zm8-8h2v-2h-2v2zm0 8c1.1 0 2-.9 2-2h-2v2zm0-12h2V7h-2v2zm0 8h2v-2h-2v2zm-4 4h2v-2h-2v2zm0-16h2V3h-2v2zM7 17h10V7H7v10zm2-8h6v6H9V9z" />
                              </svg> */}
                                <img src={selectAll}></img>
                              </div>
                            </Tooltip>
                            <Tooltip
                              title={
                                <FormattedMessage
                                  id="Lbdownload"
                                  defaultMessage="Download"
                                />
                              }
                              placement="top"
                            >
                              <div
                                className="inlineClass padding-left-20 cursurpointer"
                                onClick={this.ExportData.bind(this, true)}
                              >
                                <img src={DownloadIcon} />
                              </div>
                            </Tooltip>
                          </div>
                        )}
                        <div
                          className="planner-selected-wrapper2"
                          style={{
                            marginLeft: 0,
                            marginTop: -10,
                            height: 0,
                            float: "right",
                          }}
                        >
                          {migratedirectory && (
                            <div
                              style={{
                                float: "left",
                                width: 220,
                                marginTop: 5,
                                color: "#057cff",
                                fontWeight: 400,
                                marginRight: 8,
                                cursor: "pointer",
                              }}
                              onClick={() => {
                                window.open(migratedirectory.oldurl);
                              }}
                            >
                              View directory in sumHR 2.0
                            </div>
                          )}
                          <div
                            className="inlineClass padding-left-8 padding-top-2 floatleft"
                            style={{ marginTop: 3, marginRight: 8 }}
                          >
                            {/* <FormattedMessage id="LbMyTeam" defaultMessage="My Team" />
                             */}
                            {this.state.displayRecordCount}&nbsp;
                            <FormattedMessage
                              id="Lbof"
                              defaultMessage="of"
                            />{" "}
                            {this.state.TotalRecordCount}&nbsp;
                            <FormattedMessage
                              id="Lbemployees"
                              defaultMessage="employees"
                            />
                          </div>
                          {((this.state.empattr &&
                            this.state.empattr.permissions.editable) ||
                            (this.state.compattr &&
                              this.state.compattr.permissions.editable)) && (
                            <div className="" style={{ float: "right" }}>
                              <Button
                                size="small"
                                onClick={this.handleAddFilterClick}
                                variant="contained"
                                color="primary"
                              >
                                <i className="material-icons text-color-white">
                                  {" "}
                                  filter_list{" "}
                                </i>
                                &nbsp;Filters (
                                {this.state.selectedFilter
                                  ? this.state.selectedFilter.length
                                  : 0}
                                )
                              </Button>
                            </div>
                          )}
                          {this.state.drawerOpen && (
                            <FilterComponent
                              component="directory"
                              drawerOpen={this.state.drawerOpen}
                              parentState={this.state}
                              onFilterSave={this.onFilterSave}
                              onFilterValueChange={this.onFilterValueChange}
                              language={language}
                              handleClickAway={this.handleClickAway}
                              resetFilters={this.resetFilters}
                            />
                          )}
                        </div>
                        {CheckEditPermission("notifyEmployees") && (
                          <div
                            className="inlineClass dir-mailicon"
                            style={{ float: "left" }}
                          >
                            <div className="">
                              <Tooltip
                                title={
                                  <FormattedMessage
                                    id="_LbNotifyEmployee"
                                    defaultMessage="Notify employees"
                                  />
                                }
                                placement="top"
                              >
                                <div
                                  className="inlineClass cursurpointer"
                                  onClick={this.handleExpandClick}
                                >
                                  <img src={broadcast}></img>
                                </div>
                              </Tooltip>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </Grid>
                  <Collapse
                    in={this.state.expanded}
                    timeout="auto"
                    unmountOnExit
                    className="margin-top-20"
                    style={{ width: "99%" }}
                  >
                    <div className="width100">
                      <div className="position-rel">
                        <div
                          className="message-sent-but"
                          onClick={this.sendMail.bind(this, true, false)}
                        >
                          <FormattedMessage id="BtSend" defaultMessage="send" />
                        </div>
                        <ReactQuill
                          theme="snow"
                          modules={modules}
                          formats={formats}
                          value={this.state.fields.mailbody}
                          onChange={this.OnFieldChange.bind(
                            this,
                            "mailbody",
                            "text",
                          )}
                          className="dir-quill"
                        />
                      </div>
                    </div>
                  </Collapse>
                  <Divider className="width100" style={{ marginTop: 20 }} />
                  <div
                    className="width100 dir-emp-tab thin-scroll"
                    style={this.state.displayRecordCount != 0 ? { height:"calc(90vh - 132px)", overflowY: "auto" } : {}}
                  >
                    <div
                      position="static"
                      color="default"
                      style={{ borderBottom: "1px solid #ddd" }}
                    >
                      <Tabs
                        value={value}
                        onChange={this.ChangeofMembers.bind(this)}
                        indicatorColor="primary"
                        textColor="primary"
                      >
                        <Tab
                          label={
                            <FormattedMessage
                              id="TabMyReportees"
                              defaultMessage="My Reportees"
                            />
                          }
                          disabled={value === 0}
                        />
                        <Tab
                          label={
                            <FormattedMessage
                              id="TabMyTeam"
                              defaultMessage="My Team    "
                            />
                          }
                          disabled={value === 1}
                        />
                        <Tab
                          label={
                            <FormattedMessage
                              id="TabMyDepartment"
                              defaultMessage="My Department"
                            />
                          }
                          disabled={value === 2}
                        />
                        <Tab
                          label={
                            <FormattedMessage
                              id="TabAllMembers"
                              defaultMessage="All Members"
                            />
                          }
                          disabled={value === 3}
                        />
                      </Tabs>
                    </div>
                    {value === 0 && (
                      <TabContainer>
                        {/* <div className="heading-pannel">
                                        <p><FormattedMessage id="LbAdministrators" defaultMessage="Administrators" /></p>
                                    </div> */}
                        <EmpDirectoryDetails
                          SelectAllFlag={this.state.SelectAllFlag}
                          selectedFilter={this.state.selectedFilter}
                          getList={this.getList}
                          getEmpList={this.state.getEmpList}
                          offset={this.state.offset}
                          rowsPerPage={this.state.rowsPerPage}
                          filterid="1"
                          {...this.props}
                          isExport={this.state.isExport}
                          ExportData={this.ExportData.bind(this)}
                          mailbody={this.state.fields.mailbody}
                          isSendMail={this.state.isSendMail}
                          expandClose={this.state.expandClose}
                          sendMail={this.sendMail.bind(this)}
                        />
                      </TabContainer>
                    )}
                    {value === 1 && (
                      <TabContainer>
                        <EmpDirectoryDetails
                          SelectAllFlag={this.state.SelectAllFlag}
                          selectedFilter={this.state.selectedFilter}
                          getList={this.getList}
                          getEmpList={this.state.getEmpList}
                          offset={this.state.offset}
                          rowsPerPage={this.state.rowsPerPage}
                          // isteammember={this.state.isteammember}
                          filterid="2"
                          {...this.props}
                          isExport={this.state.isExport}
                          ExportData={this.ExportData.bind(this)}
                          mailbody={this.state.fields.mailbody}
                          isSendMail={this.state.isSendMail}
                          expandClose={this.state.expandClose}
                          sendMail={this.sendMail.bind(this)}
                        />
                      </TabContainer>
                    )}
                    {value === 2 && (
                      <TabContainer>
                        <EmpDirectoryDetails
                          SelectAllFlag={this.state.SelectAllFlag}
                          selectedFilter={this.state.selectedFilter}
                          getList={this.getList}
                          getEmpList={this.state.getEmpList}
                          offset={this.state.offset}
                          rowsPerPage={this.state.rowsPerPage}
                          // isteammember={this.state.isteammember}
                          filterid="3"
                          {...this.props}
                          isExport={this.state.isExport}
                          ExportData={this.ExportData.bind(this)}
                          mailbody={this.state.fields.mailbody}
                          isSendMail={this.state.isSendMail}
                          expandClose={this.state.expandClose}
                          sendMail={this.sendMail.bind(this)}
                        />
                      </TabContainer>
                    )}
                    {value === 3 && (
                      <TabContainer>
                        <EmpDirectoryDetails
                          SelectAllFlag={this.state.SelectAllFlag}
                          selectedFilter={this.state.selectedFilter}
                          getList={this.getList}
                          getEmpList={this.state.getEmpList}
                          offset={this.state.offset}
                          rowsPerPage={this.state.rowsPerPage}
                          // isteammember={this.state.isteammember}
                          filterid="4"
                          {...this.props}
                          isExport={this.state.isExport}
                          ExportData={this.ExportData.bind(this)}
                          mailbody={this.state.fields.mailbody}
                          isSendMail={this.state.isSendMail}
                          expandClose={this.state.expandClose}
                          sendMail={this.sendMail.bind(this)}
                        />
                      </TabContainer>
                    )}
                  </div>
                </Grid>
                <div style={{ textAlign: "center", padding: "12px 0px" }}>
                  {this.state.TotalRecordCount !=
                    this.state.displayRecordCount && (
                    <Button
                      className="btn btn-secondary-sm-blue"
                      onClick={this.handleScroll1}
                    >
                      Load more
                    </Button>
                  )}
                  {this.state.TotalRecordCount ==
                    this.state.displayRecordCount &&  this.state.displayRecordCount != 0 && (
                    <p className="normal-dark">! You have load it all</p>
                  )}
                </div>
              </div>
            </div>
          </main>
        )}
      </IntlProvider>
    );
  }
}

Directory.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  Language: state.LanguageAction.Language,
  all: state,
  AuthenticationAction: state.AuthenticationAction,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      ChangeLanguage: (data) => ChangeLanguage(data),
    },
    dispatch,
  );
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles, { withTheme: true })(withSnackbar(Directory)));
